import { createChatStore } from '@myela/ai-core-react/store';

export const chatStore = createChatStore();
